import React from 'react';


const Icon = ({ icon, width, height, stroke, color, className }) => {

	const bed = (
		<svg className={className}
			viewBox="0 0 20 16"
			width={width ? width : 20}
			height={height ? height : 16}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g id="Icon_Stay_Hotel" data-name="Icon/Stay/Hotel" transform="translate(-61 -32)">
				<g id="Icon">
				<path id="Shape" d="M63.583,48H61V32h1.969v9.035h7.879V34.007h6.212A3.983,3.983,0,0,1,81,38.023V48H78.25V44.047H63.583V48Zm3.326-8.911a3.012,3.012,0,1,1,2.955-3.011A2.987,2.987,0,0,1,66.909,39.09Z" fill={color} />
				</g>
			</g>
		</svg>
	);

	const plane = (
		<svg className={className}
			viewBox="0 0 20 20"
			width={width ? width : 20}
			height={height ? height : 20}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g id="Icon_Transport_Plane" data-name="Icon/Transport/Plane" transform="translate(-156.653 -29.83)">
				<path id="Shape" d="M176.324,50H157.379v-2.43h18.946V50Zm-17.072-5.164h0l-.773-1.615-1.826-3.84,1.455-.473,1.976,1.871,4.986-1.616-4.154-8.712,1.936-.619,6.923,7.813,5.328-1.725a1.248,1.248,0,0,1,.4-.065,1.58,1.58,0,0,1,1.451,1.353,1.909,1.909,0,0,1-1.074,2.247l-5.327,1.725-4.365,1.41-5.327,1.725-1.6.522Z" fill={color} />
			</g>
		</svg>
	);

	const taxi = (
		<svg className={className}
			viewBox="0 0 20 20"
			width={width ? width : 20}
			height={height ? height : 20}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g id="Icon_Transport_Texi" data-name="Icon/Transport/Texi" transform="translate(-255 -30)">
				<g id="icon_headermenu_taxi" data-name="icon/headermenu/taxi">
				<g id="Group_5" data-name="Group 5">
					<path id="Path" d="M0,2.217.881,0H14.675l.881,2.217Z" transform="translate(257.222 32.199)" fill={color} />
					<path id="Shape" d="M273.889,50h-1.112a1.137,1.137,0,0,1-1.111-1.16V47.681H258.333V48.84A1.138,1.138,0,0,1,257.222,50h-1.111A1.138,1.138,0,0,1,255,48.84V39.565l2.311-6.944a1.667,1.667,0,0,1,1.578-1.171h2.778V30h6.666v1.45h2.778a1.667,1.667,0,0,1,1.578,1.171L275,39.565V48.84A1.138,1.138,0,0,1,273.889,50Zm-2.777-9.278a1.741,1.741,0,1,0,1.667,1.74A1.706,1.706,0,0,0,271.112,40.722Zm-12.223,0a1.741,1.741,0,1,0,1.667,1.74A1.706,1.706,0,0,0,258.889,40.722Zm0-7.535L257.223,38.4h15.556l-1.667-5.217H258.89Z" fill={color} />
				</g>
				</g>
			</g>
		</svg>
	);

	const star = (
		<svg className={className}
			viewBox="0 0 19 18"
			width={width ? width : 19}
			height={height ? height : 18}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M14.0912 17.8288L9.33219 15.3438L4.57419 17.8288C4.41991 17.9092 4.24626 17.9448 4.07281 17.9318C3.89936 17.9188 3.73299 17.8576 3.59245 17.7551C3.45191 17.6526 3.34279 17.5129 3.27737 17.3517C3.21195 17.1905 3.19284 17.0143 3.22219 16.8428L4.13019 11.5898L0.285191 7.86884C0.159786 7.74749 0.0709257 7.5934 0.028702 7.42409C-0.0135217 7.25477 -0.00741702 7.07701 0.0463259 6.91099C0.100069 6.74497 0.199293 6.59735 0.33273 6.48489C0.466166 6.37244 0.628464 6.29967 0.80119 6.27483L6.11919 5.50684L8.50019 0.722832C8.57748 0.567329 8.69662 0.436479 8.84423 0.345009C8.99184 0.253538 9.16204 0.205078 9.33569 0.205078C9.50934 0.205078 9.67954 0.253538 9.82715 0.345009C9.97475 0.436479 10.0939 0.567329 10.1712 0.722832L12.5482 5.50684L17.8672 6.27483C18.0399 6.29967 18.2022 6.37244 18.3357 6.48489C18.4691 6.59735 18.5683 6.74497 18.6221 6.91099C18.6758 7.07701 18.6819 7.25477 18.6397 7.42409C18.5975 7.5934 18.5086 7.74749 18.3832 7.86884L14.5352 11.5898L15.4422 16.8428C15.4726 17.0144 15.4543 17.1911 15.3892 17.3528C15.3242 17.5144 15.2151 17.6546 15.0743 17.7573C14.9336 17.8601 14.7668 17.9212 14.593 17.9339C14.4192 17.9465 14.2453 17.9101 14.0912 17.8288Z" fill={color} />
		</svg>
	);

	const check = (
		<svg className={className}
			viewBox="0 0 14 15"
			width={width ? width : 14}
			height={height ? height : 15}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M7.00586 14.3642C8.3739 14.3507 9.70739 13.9328 10.8384 13.163C11.9694 12.3932 12.8473 11.3059 13.3615 10.0381C13.8758 8.77036 14.0034 7.37875 13.7283 6.03859C13.4532 4.69842 12.7877 3.46963 11.8155 2.50696C10.8434 1.54429 9.6082 0.890807 8.26541 0.628799C6.92262 0.366791 5.53233 0.507982 4.26963 1.03459C3.00693 1.56119 1.92829 2.44966 1.16956 3.58811C0.410822 4.72655 0.0059252 6.06405 0.00585938 7.43216C0.0103134 8.34695 0.194915 9.2519 0.54911 10.0954C0.903306 10.9388 1.42016 11.7042 2.07018 12.3479C2.72019 12.9916 3.49062 13.501 4.33749 13.8469C5.18435 14.1929 6.09107 14.3686 7.00586 14.3642ZM10.5249 5.56416C10.609 5.47468 10.6549 5.35594 10.6529 5.23316C10.6509 5.11031 10.6006 4.99318 10.5129 4.90716C10.425 4.82047 10.3072 4.77088 10.1838 4.76865C10.0604 4.76642 9.94081 4.81171 9.84986 4.89516L5.75986 8.94516L4.18586 7.12716C4.10262 7.0329 3.98577 6.97498 3.86035 6.96583C3.73493 6.95667 3.61091 6.99699 3.51486 7.07816C3.4676 7.11813 3.42869 7.16704 3.40038 7.22209C3.37207 7.27714 3.35492 7.33724 3.3499 7.39894C3.34488 7.46064 3.35211 7.52272 3.37115 7.58162C3.39019 7.64052 3.42068 7.69508 3.46086 7.74216L5.14687 9.68916C5.21791 9.77274 5.30539 9.84082 5.40386 9.88916C5.50273 9.9366 5.61029 9.96321 5.71987 9.96734C5.82945 9.97147 5.93871 9.95303 6.04086 9.91316C6.14269 9.87386 6.2353 9.81394 6.31287 9.73716L10.5249 5.56416Z" fill={color} />
		</svg>
	);

	switch (icon) {
		case "bed":
			return bed;
		case "plane":
			return plane;
		case "taxi":
			return taxi;
		case "star":
			return star;
		case "check":
			return check;
		default:
			return null;
  	}
}



//default look of our icons
//pass width, height and stroke props to override these
Icon.defaultProps = {
  width: "24",
  height: "24",
  stroke: "#000",
  color: "#399AB3"
};

export default Icon;
